import React from 'react';
import styled from '@emotion/styled';
import { Box, IconButton, Typography } from '@mui/material';
import RoomIcon from '@mui/icons-material/Room';
import HomeIcon from '@mui/icons-material/Home';
import PermIdentity from '@mui/icons-material/PermIdentity';
import DescriptionIcon from '@mui/icons-material/Description';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { setStep } from '../habitationSlice';

const StepContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
`;

const Step = styled(Box)<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ $active }) => ($active ? '#8CCDCD' : '#b0bec5')};
`;

const StepLine = styled(Box)<{ $active?: boolean }>`
  width: 50px;
  height: 2px;
  background-color:${({ $active }) => ($active ? '#8CCDCD' : '#b0bec5')};
  margin: 0 12px;
`;

const IconButtonStyled = styled(IconButton)<{ $active?: boolean }>`
  background: ${({ $active }) => ($active ? '#8CCDCD' : 'transparent')};
  color: ${({ $active }) => ($active ? 'white' : '#8CCDCD')};
  border: ${({ $active }) => ($active ? '0px' : 'solid 1px #8CCDCD')};
`


const StepperHeader: React.FC = () => {
  const dispatch = useAppDispatch();
  const step = useAppSelector(state => state.habitation.step);
  const lastVerifiedStep = useAppSelector(state => state.habitation.lastVerifiedStep);

  const redirectStep = (targetStep: number) => {
    if (targetStep > lastVerifiedStep + 1) return;
    // On dispatch direct le step dans Redux ; HabitationPage propage ensuite la
    // valeur à l'URL via son useEffect [step] qui préserve les autres query
    // params (?school=, etc.) avec params.toString().
    dispatch(setStep(targetStep));
  };

  return (
    <StepContainer>
      <Step $active={step >= 1} >
        <IconButtonStyled
          $active={step >= 1}
          onClick={() => redirectStep(1)}
          >
          <RoomIcon />
        </IconButtonStyled>
        <Typography variant="caption">Adresse</Typography>
      </Step>

      <StepLine $active={step >= 2} />

      <Step $active={step >= 2}>
        <IconButtonStyled
          $active={step >= 2}
          onClick={() => redirectStep(2)}
          >
          <HomeIcon />
        </IconButtonStyled>

        <Typography variant="caption">Logement</Typography>
      </Step>

      <StepLine $active={step >= 3} />

      <Step $active={step >= 3}>
        <IconButtonStyled
          $active={step >= 3}
          onClick={() => redirectStep(3)}
          >
          <PermIdentity />
        </IconButtonStyled>
        <Typography variant="caption">Informations</Typography>
      </Step>

      <StepLine $active={step >= 4} />

      <Step $active={step >= 4}>
        <IconButtonStyled
          $active={step >= 4}
          onClick={() => redirectStep(4)}
          >
          <DescriptionIcon />
        </IconButtonStyled>
        <Typography variant="caption">Devis</Typography>
      </Step>
    </StepContainer>
  );
};

export default StepperHeader;